import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MeasureDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-measure',
  templateUrl: './measure.component.html',
  styleUrls: ['./measure.component.scss']
})
export class MeasureComponent implements OnChanges {


  measureForm: FormGroup;
  measureFormArray: FormGroup;
  control = new FormControl();
  @Input() measures: MeasureDto[];
  @Input() routeAnimationsElements: any;
  @Output() measure = new EventEmitter<MeasureDto[]>()
  @Output() deleteMeasureEvent = new EventEmitter<any>()

    selectedMeasure: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createMeasureForm();
    }

    createMeasureForm() {
      this.measureForm = this.fb.group({
        MeasureName: ['', Validators.required],
      GroundRentAmount: ['', Validators.required],
        id: null
        });
        this.measureFormArray = this.fb.group({ Measures: this.fb.array([])
          });
        this.setMeasure();
    }

  // method to display measures
  setMeasure() {
    const control  = this.measureFormArray.controls.Measures as FormArray;
    this.measures.forEach( e => {
      control.push(
        this.fb.group({
          MeasureName: e.MeasureName,
         GroundRentAmount: e.GroundRentAmount,
          id: e.id
        })
      );
    });
  }


  // method to add Measure
  addMeasure(value: MeasureDto) {
    const control  = this.measureFormArray.controls.Measures as FormArray;
    control.insert(0,
          this.fb.group({
            MeasureName: value.MeasureName,
           GroundRentAmount:value.GroundRentAmount,
            id: null
          })
       );
  }

  selectMeasure(value) {}

  // method to delete measure from arrary list
  deleteMeasure(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.measureFormArray.controls.Measures as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.measures.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.measures[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: MeasureDto) {
    if(this.measureForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.measureFormArray.get('Measures')['controls'][this.selectedIndex].patchValue({MeasureName: formValue.MeasureName,GroundRentAmount:formValue.GroundRentAmount});
    } else {
      this.addMeasure(formValue);
    }
    this.selectedIndex = null;
    this.measureForm.reset()
  }

  onEdit(index, value: MeasureDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.measureForm.patchValue({MeasureName: value.MeasureName,GroundRentAmount:value.GroundRentAmount});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.measureForm.reset();
  }

  onSubmit(formValue: MeasureDto[]) {
  this.measure.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteMeasureEvent.emit(this.filteredDelete);
  }
  }

}
